'use strict';

import request from 'superagent';
import api from './core';

export function fetchPage(args) {
    return api.prepare(request.get(api.url('/documents/'))).query(args);
}

export function list(args) {
    return api.forwardResult(fetchPage(args), 'results');
}

export function create(document) {
    return api.forwardResult(
        api.prepare(request.post(api.url('/documents/'))).send(document),
        'id'
    );
}

export function update(document) {
    const id = encodeURIComponent(document.id);
    return api.forwardResult(
        api.prepare(request.put(api.url(`/documents/${id}/`))).send(document),
        'id'
    );
}

export function listOrphans(client) {
    const id = encodeURIComponent(client.id);
    const req = api.prepare(request.get(api.url(`/clients/${id}/orphan_docs/`)));
    return api.forwardResult(req, 'results');
}



// WEBPACK FOOTER //
// ./src/api/documents.js